module.exports = __webpack_public_path__ + "img/baogaochaxun.885e5088.jpg";